
import { onMounted, ref } from "vue";
import axios from "axios";
import { User } from "@/models/user";

import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
  name: "AdminUserList",
  components: { VPagination },
  setup() {
    const users = ref([]);
    const lastPage = ref(0);
    const search = ref("");

    const load = async (page = 1) => {
      const { data } = await axios.get(
        `users?page=${page}&take=50&search=${search.value}`
      );
      users.value = data.data;
      lastPage.value = data.meta.last_page;
    };

    onMounted(load);

    const del = async (id: number) => {
      if (confirm("Are You Sure?")) {
        await axios.delete(`users/${id}`);

        users.value = users.value.filter((u: User) => u.id !== id);
      }
    };
    const searchcall = async () => {
      load();
    };
    const searchclear = async () => {
      search.value = "";

      load();
    };

    return {
      users,
      lastPage,
      search,
      del,
      load,
      searchcall,
      searchclear,
    };
  },
};
